import { render, staticRenderFns } from "./age-filter.vue?vue&type=template&id=36502a30"
import script from "./age-filter.vue?vue&type=script&lang=js"
export * from "./age-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports